import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ThemeMode, ColorTheme, ColorMode, ThemeState } from './types';

// Default theme is LIGHT for a fresh visit. Existing users keep whatever
// theme they previously chose because `redux-persist` rehydrates over
// this initial state. Update both this default AND the static
// `data-theme` attribute on `<html>` in each app's index.html so the
// first paint matches and there's no dark→light flash on load.
const initialState: ThemeState = {
  mode: 'light',
  // Zouk Teal — palette audited from zouk.co.in 2026-06-11. Deep
  // petrol teal on cream/white surfaces. Existing users keep whatever
  // color they previously picked because redux-persist rehydrates
  // over this initial state.
  colorTheme: 'zouk',
  colorMode: 'multi',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
    },
    setColorTheme(state, action: PayloadAction<ColorTheme>) {
      state.colorTheme = action.payload;
    },
    setColorMode(state, action: PayloadAction<ColorMode>) {
      state.colorMode = action.payload;
    },
  },
});

export const { toggleMode, setMode, setColorTheme, setColorMode } = themeSlice.actions;
export default themeSlice.reducer;
